import { useState, useCallback } from 'react';
import { defaultFiltersPayload } from '@/creditflowresearch/application/Bonds/constants';
import { IBondsFilterItems, IBondsFilterState } from '@/creditflowresearch/domain/vo/Bond/BondsFiltersContextData';

export const INITIAL_ITEMS: IBondsFilterItems = {
  filter: {},
  hash: '',
};

export const useBondFilterState = (initial: IBondsFilterState) => {
  const [isFetching, setIsFetching] = useState(false);
  const [items, setItems] = useState<IBondsFilterItems>(INITIAL_ITEMS);
  const [initialFilters, setInitialFilters] = useState<IBondsFilterState>(initial);
  const [appliedFilters, setAppliedFilters] = useState<IBondsFilterState>(() => initial);
  const [filtersPayload, setFiltersPayload] = useState<IBondsFilterState | null>(() => initial);
  const [dateFromMin, setDateFromMin] = useState<number | null>(null);
  const [dateToMax, setDateToMax] = useState<number | null>(null);

  const setMinMaxDatePeriod = useCallback((dateFrom: number, dateTo: number) => {
    setDateFromMin(dateFrom);
    setDateToMax(dateTo);
  }, []);

  const resetState = useCallback(() => {
    setIsFetching(false);
    setItems(INITIAL_ITEMS);
    setInitialFilters(defaultFiltersPayload);
    setAppliedFilters(defaultFiltersPayload);
    setFiltersPayload(null);
    setDateFromMin(null);
    setDateToMax(null);
  }, []);

  return {
    isFetching,
    items,
    initialFilters,
    appliedFilters,
    filtersPayload,
    dateFromMin,
    dateToMax,
    setIsFetching,
    setItems,
    setInitialFilters,
    setAppliedFilters,
    setFiltersPayload,
    setMinMaxDatePeriod,
    resetState,
  };
};
